import useSWR from "swr";
import { useSearchParams } from "react-router-dom";

import { useApiAccess } from "./useApiAccess";
import { getSubcategories } from "../../Service/CategoryService";
import { apiRoutes } from "../../Constants/ApiRoutes";

export const useSubCategories = ({ categorySlug }) => {
    const hasAccess = useApiAccess();
    const [searchParams] = useSearchParams();
    const productParam = searchParams.get('product');

    const pathParams = {
        ...(productParam && { product: productParam }),
    };

    return useSWR(
        hasAccess && categorySlug ? `${apiRoutes.subCategories}${categorySlug}` : null,
        () => getSubcategories({ categorySlug }, pathParams)
    );
};